import axios from 'axios'
import { getEnvVars } from '../Utils/env-utils';
var theEnv = getEnvVars(window.location.hostname);
const { apiUrl } = getEnvVars(window.location.hostname);
export const creditcardStatus = ({ patientId, errorCode, errorMessage, sessionToken }, onSuccess, onError) => {
    axios.post(`${apiUrl}/status/creditcard`, {
        patientId,
        errorCode,
        errorMessage,
        sessionToken
    }, {
        headers: {
            apikey: theEnv.REACT_APP_API_KEY_URI,
        }
    })
        .then(res => {
            console.log(res)
            onSuccess(res);
        })
        .catch(e => onError(e));
};